export interface MetricsSeries {
  name: string
  data: number[]
}

export enum SpendMetricsAggregates {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Sum = 'SUM',
}

export enum SpendMetricsPeriods {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR',
}

export enum SpendMetricsTypes {
  Currency = 'CURRENCY',
  Long = 'LONG',
}

export interface SpendMetricsResponse {
  metric: string
  aggregate: SpendMetricsAggregates
  period: SpendMetricsPeriods
  type: SpendMetricsTypes
  dataSets: number[]
  series: MetricsSeries[]
}
